import productResource from "../resources/productResource";
import Product from "../domain/product";

export default {
  async findAll () {
    const response = await productResource.query();
    if (response.ok) {
      return response.data.map((productData) => new Product(productData));
    } else {
      return null;
    }
  },
  async create (product) {
    const response = await productResource.save({}, product);
    if (response.ok) {
      return new Product(response.data);
    } else {
      return null;
    }
  },
  async update (product) {
    const response = await productResource.update({}, product);
    if (response.ok) {
      return new Product(response.data);
    } else {
      return null;
    }
  },
  async delete(id) {
    return productResource.delete({id: id});
  },
  async deactivate (id) {
    return productResource.deactivate({id: id}, {});
  },
  async activate (id) {
    return productResource.activate({id: id}, {});
  }
}



// WEBPACK FOOTER //
// ./client/services/productService.js